export const MY_APPS_IDLE_RECENT_LIMIT = 6;
export const MY_APPS_SEARCH_RESULT_LIMIT = 12;

export interface LauncherEntry {
  id: string;
}

export interface IdleLauncherSections<T extends LauncherEntry> {
  pinned: readonly T[];
  recent: readonly T[];
  items: readonly T[];
}

/** Idle Ctrl+K list: pinned first, then recent apps that are not already pinned. */
export function buildIdleLauncherSections<T extends LauncherEntry>(
  pinned: readonly T[],
  recent: readonly T[],
  recentLimit = MY_APPS_IDLE_RECENT_LIMIT
): IdleLauncherSections<T> {
  const pinnedIds = new Set(pinned.map((entry) => entry.id.toLowerCase()));
  const recentOnly = recent
    .filter((entry) => !pinnedIds.has(entry.id.toLowerCase()))
    .slice(0, recentLimit);
  return {
    pinned,
    recent: recentOnly,
    items: [...pinned, ...recentOnly]
  };
}
